import { render, staticRenderFns } from "./ArtistWorkInfo.vue?vue&type=template&id=80964482&scoped=true"
import script from "./ArtistWorkInfo.vue?vue&type=script&lang=js"
export * from "./ArtistWorkInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80964482",
  null
  
)

export default component.exports